export default {"src":"/uk/_next/static/media/summaryIconGrey.9da41592.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};